import { Navigate, useLocation, useParams } from 'react-router-dom';
import { useAuthStore } from '@auth/presentation/store/authStore';
import { orgPaths, adminPaths } from '@shared/routes/appPaths';

// Ruta neutra `/connections/:id` (canónica; `/klons/:id` se conserva como compatibilidad con los emails
// anteriores a h16a, ambas apuntan aquí): resuelve el contexto de rol en el frontend y
// reenvía a la ruta real del detalle de connection preservando query string y hash.
// Gemelo de RoleRedirect, parametrizado por :id (los emails apuntan aquí para
// servir a los tres roles sin que el backend conozca rol ni slug).
export default function ConnectionRedirect() {
  const { id } = useParams<{ id: string }>();
  const { search, hash } = useLocation();
  const user = useAuthStore((s) => s.user);

  const suffix = `${search}${hash}`;

  if (user?.role === 'superadmin') {
    return <Navigate to={`${adminPaths.connection(id ?? '')}${suffix}`} replace />;
  }

  if (user?.organizationSlug) {
    return <Navigate to={`${orgPaths.connection(user.organizationSlug, id ?? '')}${suffix}`} replace />;
  }

  // Defensivo: usuario sin slug que no es superadmin (estado inconsistente del authStore).
  return <Navigate to="/auth/login" replace />;
}
